import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc'
import { DateFilters } from "../enums/DateFilters";
import { DateFilter } from "../interfaces/DateFilter";
import { TimeUnit } from '../enums/TimeUnit';

const DATE_FILTER_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const CHART_DATE_FORMAT = 'MMM DD';

class DateHelper {
  public static getDateFormatted(date: Date): string {
    return dayjs(date).format(DATE_FILTER_FORMAT);
  }

  public static calculateTimeDifferenceFromNow(to: dayjs.Dayjs): string {
    dayjs.extend(relativeTime);

    return to.fromNow();
  }

  public static getDateFilterByDateName(dateName: DateFilters): DateFilter | null {
    dayjs.extend(utc);
    const now = dayjs.utc();
    const filters = {
      [DateFilters.LAST_HOUR]: {
        name: DateFilters.LAST_HOUR,
        start: now.subtract(1, TimeUnit.HOUR).format(DATE_FILTER_FORMAT),
        end: now.format(DATE_FILTER_FORMAT)
      },
      [DateFilters.LAST_3_HOURS]: {
        name: DateFilters.LAST_3_HOURS,
        start: now.subtract(3, TimeUnit.HOUR).format(DATE_FILTER_FORMAT),
        end: now.format(DATE_FILTER_FORMAT)
      },
      [DateFilters.LAST_24_H]: {
        name: DateFilters.LAST_24_H,
        start: now.subtract(1, TimeUnit.DAY).format(DATE_FILTER_FORMAT),
        end: now.format(DATE_FILTER_FORMAT)
      },
      [DateFilters.LAST_72_H]: {
        name: DateFilters.LAST_72_H,
        start: now.subtract(3, TimeUnit.DAY).format(DATE_FILTER_FORMAT),
        end: now.format(DATE_FILTER_FORMAT)
      },
      [DateFilters.LAST_MONTH]: {
        name: DateFilters.LAST_MONTH,
        start: now.subtract(30, TimeUnit.DAY).format(DATE_FILTER_FORMAT),
        end: now.format(DATE_FILTER_FORMAT)
      },
      [DateFilters.LAST_7_DAYS]: {
        name: DateFilters.LAST_7_DAYS,
        start: now.subtract(7, TimeUnit.DAY).format(DATE_FILTER_FORMAT),
        end: now.format(DATE_FILTER_FORMAT)
      },
      [DateFilters.ANYTIME]: null,
      [DateFilters.CUSTOM_DATE]: null
    };

    return filters[dateName];
  }

  public static getFirstDayOfPreviousMonth(): string {
    const now = new Date();

    return dayjs(new Date(now.getFullYear(), now.getMonth() - 1, 1)).format(DATE_FORMAT);
  }
}

export default DateHelper;
